import ApiCall from "../constants/Api";
import { helpAxios } from "../helpers/helpAxios";
import { errorHandler } from "../components/ErrorHandler";

export const useSpecialFunctions = () => {
  //LoginUser function
  const loginUser = async (request) => {
    let response;
    try {
      response = await helpAxios("", ApiCall.LOGIN_USER, {
        ...request,
      });

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  //LogoutUser function
  const logoutUser = async (LogonSessionID) => {
    let response;
    try {
      response = await helpAxios("", ApiCall.LOGOUT_USER, {}, LogonSessionID);

      if (response.error) {
        errorHandler(response.error, response.errorDetails);
      }
    } catch (error) {
      errorHandler(error.toString());
    }

    return response;
  };

  // Get the time from a dateTime and format it
  const getTimeInfo = (time) => {
    var postTime = new Date(time);
    return (
      ("0" + postTime.getHours()).slice(-2) +
      ":" +
      ("0" + postTime.getMinutes()).slice(-2) +
      ":" +
      ("0" + postTime.getSeconds()).slice(-2)
    );
  };

  // Get the time from a dateTime and format it
  const getHoursMinutes = (time) => {
    var postTime = new Date(time);
    return (
      ("0" + postTime.getHours()).slice(-2) +
      ":" +
      ("0" + postTime.getMinutes()).slice(-2)
    );
  };

  // Get the date from a date and format it
  const getDateInfo = (date) => {
    var postTime = new Date(date);
    return (
      ("0" + (postTime.getMonth() + 1)).slice(-2) +
      "/" +
      ("0" + postTime.getDate()).slice(-2) +
      "/" +
      postTime.getFullYear()
    );
  };

  // Get the date from a UTC date and format it
  const getUTCDateInfo = (date) => {
    const postTime = new Date(date);
    return (
      ("0" + (postTime.getUTCMonth() + 1)).slice(-2) +
      "/" +
      ("0" + postTime.getUTCDate()).slice(-2) +
      "/" +
      postTime.getUTCFullYear()
    );
  };

  const checkHasUpgrade = (trackPackages) => {
    if (!trackPackages?.length) return false;

    const now = new Date();

    return trackPackages.some((pkg) => {
      if (!pkg.Expiration) return false;

      const expirationDate = new Date(pkg.Expiration);

      const diffTime = expirationDate.getTime() - now.getTime();

      const diffDays = diffTime / (1000 * 60 * 60 * 24);

      return diffDays <= 7 && diffDays >= 0;
    });
  };

  const isExpiringSoon = (date) => {
    if (!date) return false;

    const [year, month, day] = date.split("T")[0].split("-");

    const today = new Date();
    const expDate = new Date(year, month - 1, day);

    today.setHours(0, 0, 0, 0);

    const diffDays = (expDate - today) / (1000 * 60 * 60 * 24);

    return diffDays <= 7 && diffDays >= 0;
  };

  const getDaysLeft = (date) => {
    if (!date) return null;

    const diff =
      (new Date(date).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24);

    return Math.ceil(diff);
  };

  const getExpireText = (date) => {
    const days = getDaysLeft(date);

    if (days === 0) return "Expires today";
    if (days === 1) return "Expires tomorrow";
    return `Expires in ${days} days`;
  };

  return {
    loginUser,
    logoutUser,
    getTimeInfo,
    getHoursMinutes,
    getDateInfo,
    getUTCDateInfo,
    checkHasUpgrade,
    isExpiringSoon,
    getDaysLeft,
    getExpireText,
  };
};
